import { Typography } from 'app/components/ui';
import './MenuTabs.scss';

export interface MenuTab {
  key: 'taxonomy' | 'allTags' | 'tagInfo' | 'test';
  label: string;
}

interface MenuTabsProps {
  tabs: MenuTab[];
  activeTab: string;
  onTabChange: (key: string) => void;
}

export const MenuTabs = ({ tabs, activeTab, onTabChange }: MenuTabsProps) => (
  <div className="menu-tabs">
    {tabs.map((tab) => (
      <button key={tab.key} className={`menu-tabs__button${activeTab === tab.key ? ' menu-tabs__button--active' : ''}`} onClick={() => onTabChange(tab.key)}>
        <Typography variant="body-7" fontWeight="semibold" color={activeTab === tab.key ? '#000000' : '#84919E'}>
          {tab.label}
        </Typography>
      </button>
    ))}
  </div>
);
